import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label } from "reactstrap";
import { createSelector } from 'reselect';
import { toggleFigmaPluginModal } from '../../../../../../slices/modals/reducer';
import Preloader from '../../../../../../Components/Common/Preloader';
import { setCreativeOpenedInFigma, setScrolledCreatives, updateCreatives, updateScrolledCreatives } from '../../../../../../slices/campaigns/reducer';

function FigmaPluginModal() {
  const dispatch = useDispatch();
  const selectModalState = createSelector(state => state, state => ({
    modalState: state.Modal.figmaPluginModal,
    pluginLoader: state.Modal.pluginLoader,
    scrolledCreatives: state.Campaign.scrolledCreatives,
    creativeOpenedInFigma: state.Campaign.creativeOpenedInFigma
  }));
  const { modalState, pluginLoader, scrolledCreatives, creativeOpenedInFigma } = useSelector(selectModalState);

  function closeModal() {
    dispatch(updateCreatives({...creativeOpenedInFigma, isLoading: false}));
    dispatch(updateScrolledCreatives({...creativeOpenedInFigma, isLoading: false}));
    // const savedScrolledCreatives = scrolledCreatives;
    // dispatch(setScrolledCreatives([]));
    // setTimeout(() => {
      // dispatch(setScrolledCreatives(savedScrolledCreatives));
      dispatch(toggleFigmaPluginModal());
      dispatch(setCreativeOpenedInFigma(null));
    // }, 1);
  }

  return (
    <React.Fragment>
      {pluginLoader ?
        <Preloader />
        :
        <Modal isOpen={modalState} toggle={closeModal} centered size='xl' fullscreen={true}>
          <ModalHeader className='p-0 figma-modal-header' toggle={closeModal}>
          </ModalHeader>
          <ModalBody id='figma-modal-body' className='px-0 py-0' style={{ overflow: 'hidden' }}>
          </ModalBody>
        </Modal>
      }

    </React.Fragment>
  )
}

export default FigmaPluginModal;
